import {
    useEffect,
    useState,
} from 'react';
import { getJson } from '~shared/utils/http';

export const useService = (url, { lazyLoadHasLoaded, lazyLoadIsEmpty }) => {
    const [data, setData] = useState([]);

    const getData = async () => {
        const response = await getJson(url);
        if (!response.ok) {
            lazyLoadIsEmpty();

            return;
        }

        const respData = await response.json();
        if (respData.length) {
            setData(respData);
            lazyLoadHasLoaded();
        } else {
            lazyLoadIsEmpty();
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return data;
};
